import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'mapa',
    pathMatch: 'full'
  },
  {
    path: 'mapa',
    loadChildren: './home/home.module#HomePageModule',
  },
  {
    path: 'mapa/:idprovincia',
    loadChildren: './home/home.module#HomePageModule',
  },
  {
    path: 'mapa/:idprovincia/:idciudad',
    loadChildren: './home/home.module#HomePageModule',
  },
  {
    path: 'lista',
    loadChildren: './list/list.module#ListPageModule'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
